// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","nav":"nav-module_nav_0VX","loader":"nav-module_loader_XSW"};